import * as React from 'react';

import Layout, { FooterType, HeaderType } from '@opendoor/bricks/deprecated/UNSAFE_layout/Layout';

import { isOpendoorAppEvoWebView } from 'src/helpers/webview';

type ExclusivesLayoutProps = {
  footerType?: FooterType;
  headerType?: HeaderType;
  hideHeaderMobile?: boolean;
  renderExtra?: () => JSX.Element;
};

export const ExclusivesLayout: React.FC<React.PropsWithChildren<ExclusivesLayoutProps>> = ({
  children,
  footerType,
  headerType,
  renderExtra,
}) => (
  <Layout
    analyticsName="reception-fe-exclusives"
    footerType={isOpendoorAppEvoWebView ? 'NONE' : footerType}
    headerType={isOpendoorAppEvoWebView ? 'NONE' : headerType}
    hideHeaderMobile
    renderExtra={renderExtra}
  >
    {children}
  </Layout>
);
